// import Vue from 'vue'
import { TYPE_SHELF } from "./typeStructure";

export const shelfConfig = {
    namespaced: true,
    state: {
        width: 0,
        height: 0,
        depth: 0,
        posHookX: [],
        posHookY: [],
        posModX: [],
        posModY: 0,
        maxlengthChar: 0,
        type: TYPE_SHELF,
        hookInverse: false,
        baseShelf: false
    },
    getters: {
        getShelfWidth(state) {
            return state.width;
        },
        getShelfHeight(state) {
            return state.height;
        },
        getShelfDepth(state) {
            return state.depth;
        },
        getPosHookX(state) {
            return state.posHookX;
        },
        getPosHookY(state) {
            return state.posHookY;
        },
        getPosModX(state) {
            return state.posModX;
        },
        getPosModY(state) {
            return state.posModY;
        },

        getMaxlengthChar(state) {
            return state.maxlengthChar;
        },

        getType(state) {
            return state.type;
        },
        isHookInverse(state) {
            return state.hookInverse;
        },

        isBaseShelf(state) {
            return state.baseShelf;
        }
    },

    mutations: {
        SET_SHELF_WIDTH(state, width) {
            state.width = width;
        },

        SET_SHELF_HEIGHT(state, height) {
            state.height = height;
        },

        SET_SHELF_DEPTH(state, depth) {
            state.depth = depth;
        },

        SET_POSX_HOOK(state, posHookX) {
            state.posHookX = posHookX;
        },

        SET_POSY_HOOK(state, posHookY) {
            state.posHookY = posHookY;
        },

        SET_POSX_MOD(state, posModX) {
            state.posModX = posModX;
        },

        SET_POSY_MOD(state, posModY) {
            state.posModY = posModY;
        },

        SET_MAXLENGTH_CHAR(state, maxlength) {
            state.maxlengthChar = maxlength;
        },

        SET_TYPE(state, type) {
            state.type = type;
        },

        SET_HOOK_INVERSE(state, hookInverse) {
            state.hookInverse = hookInverse;
        },

        SET_CONFIG(state, config) {
            state.width = config.width;
            state.height = config.height;
            state.depth = config.depth;
            state.posHookX = config.posHookX;
            state.posHookY = config.posHookY;
            state.posModX = config.posModX;
            state.posModY = config.posModY;
            state.type = config.type;
            state.hookInverse = config.hookInverse;
            state.baseShelf = config.baseShelf;
            state.maxlengthChar = config.maxlengthChar;
        },

        SET_BASE_SHELF(state, baseShelf) {
            state.baseShelf = baseShelf;
        }
    },

    actions: {
        setShelfWidth(context, width) {
            context.commit("SET_SHELF_WIDTH", width);
        },
        setShelfHeight(context, height) {
            context.commit("SET_SHELF_HEIGHT", height);
        },
        setShelfDepth(context, depth) {
            context.commit("SET_SHELF_DEPTH", depth);
        },
        setPosHookX(context, posHookX) {
            context.commit("SET_POSX_HOOK", posHookX);
        },
        setPosHookY(context, posHookY) {
            context.commit("SET_POSY_HOOK", posHookY);
        },
        setPosModX(context, posModX) {
            context.commit("SET_POSX_MOD", posModX);
        },
        setPosModY(context, posModY) {
            context.commit("SET_POSY_MOD", posModY);
        },

        setMaxlengthChar(context, maxlength) {
            context.commit("SET_MAXLENGTH_CHAR", maxlength);
        },

        setType(context, type) {
            context.commit("SET_TYPE", type);
        },

        setHookInverse(context, hookInverse) {
            context.commit("SET_HOOK_INVERSE", hookInverse);
        },

        setConfig(context, config) {
            context.commit("SET_CONFIG", config);
        },

        setBaseShelf(context, baseShelf) {
            context.commit("SET_BASE_SHELF", baseShelf);
        }
    }
};



// WEBPACK FOOTER //
// ./src/store/catalog/shelfConfig.js